import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  { path: "/", redirect: "/index" },
  { path: "/index", component: () => import("@/components/Index.vue") },
  {
	  path: "/adminIndex",
	  component: () => import("@/components/AdminIndex.vue"),
  },
  {
    path: "/404",
    component: () => import("@/components/404/404.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = new VueRouter({
  routes,
});
// //挂载路由导航守卫
router.beforeEach((to, from, next) => {
  //to将要访问的路径
  //from代表从哪个路径跳转而来
  //next是一个函数表示放行
  const tokenStr = window.sessionStorage.getItem("token");
  if (true) {
    next();
  } else {
    // 用户未登录判断
    if (
	  to.path === "/index"
    ) {
      next();
    } else {
      next({ path: "/index" });
    }
  }
});
export default router
